import type { EpaysageCtx } from "@repo/print-pdf/epaysage/template";

/** Espace boisé d'exemple pour l'aperçu de l'éditeur (sans appel au serveur). */
const base = {
  organizationName: "Racines et Cimes",
  organizationAddress: "12 avenue des Tilleuls",
  organizationCity: "75000 Paris",
  organizationZipCode: "75000",
  organizationSiret: "123 456 789 00012",
  organizationNumCertification: "",
  organizationLogo: null,
  user: { prenom: "Démo", nom: "Admin" },
  formattedDate: "21/10/2026",
  addressLine: "Parc des Tilleuls, Paris",
  code_site: "S1",
  num_sujet: "1",
  type_espace: "Parc urbain",
  surface: "1 200 m²",
  totalSubjects: "30",
  gps: "48.85, 2.35",
  caracteristiques: {
    milieu: "Urbain",
    sol: "Argileux",
    domaine: "Public",
    proximite: "Route",
    accessibilite: "Libre",
    taux_freq: "Fort",
    type_passage: "Piéton",
    age_estime: "40 ans",
  },
  environnement: { nuisance: "Bruit", situation: "Centre-ville" },
  risque: { general: "Faible" },
  img1: null,
  img2: null,
  img3: null,
  comments: "Commentaire d'exemple.",
};

const essence = (over: Record<string, unknown>) => ({
  diametre: "35 cm",
  hauteur: "14 m",
  stade_dev: "Adulte",
  port_arbre: "Libre",
  etat_san_general: "Bon",
  risque: "Faible",
  critere: "Aucun",
  img1: null,
  img2: null,
  ...over,
});

export const SAMPLE_EPAYSAGE_DATA = {
  ...base,
  organization: null,
  headerTitle: "Espace boisé – 1",
  essences: ["Quercus robur", "Fagus sylvatica"],
  essence: [
    essence({
      count_subject: 18,
      travaux_taille_sanitaire: 4,
      travaux_com: "À planifier",
    }),
    essence({ count_subject: 12, etat_san_general: "Moyen", risque: "Modéré" }),
  ],
} as unknown as EpaysageCtx["data"];
